import { makeDate } from "./utils.js";
/*
    Legacy Personalisation Extension

    Works by comparing key/value pairs 
*/

//
// Namespace
//

export var sq_personalise = {
    'fn': {},
    'vars': {}
};


//
// Utilities
//

// Sort an array of objects by a value in ascending order
function sortAscBy(sort_key) {
    return function (item_a, item_b) {
        if(item_a[sort_key] > item_b[sort_key]) {
            return 1;
        }

        if(item_b[sort_key] > item_a[sort_key]) {
            return -1;
        }

        return 0;
    };
}

// Sort an array of objects by a value in descending order
function sortDescBy(sort_key) {
    return function (item_a, item_b) {
        if(item_a[sort_key] < item_b[sort_key]) {
            return 1;
        }

        if(item_b[sort_key] < item_a[sort_key]) {
            return -1;
        }

        return 0;
    };
}

// Convert structured attributes
function checkAttributeStructure(attribute_value, attribute_data) {
    var attribute_key = attribute_data['key'];
    var structured_attributes = ['SRV_INDCTR', 'TO_DO_LIST'];
    
    if(structured_attributes.indexOf(attribute_key) !== -1) {
        // Create an array if it's an object
        if(!Array.isArray(attribute_value)) {
            attribute_value = [attribute_value];
        }
    }

    return attribute_value;
}

// Convert attribute types
function checkAttributeType(attribute_value, attribute_data) {
    var attribute_type = attribute_data['type'];

    switch(attribute_type) {
        case 'boolean':
            attribute_value = convertBoolean(attribute_value);
            break;
        case 'date':
            attribute_value = convertDate(attribute_value);
            break;
    }

    return attribute_value;
}

// Convert strings to booleans
function convertBoolean(attribute_value) {
    if(attribute_value === 'T') {
        return true;
    } else {
        return false;
    }
}

// Convert strings to date objects
function convertDate(attribute_value) {
    return new Date(attribute_value);
}

// Convert datestring to date
function showDate(attribute_value) {
    /*var new_date = moment(new Date(), 'DD/MM/YYYY');
        
    return new_date.format('DD/MM/YYYY');*/

    var date_format = 'DD/MM/YYYY';
    var new_date = makeDate(new Date(attribute_value), date_format);

    return new_date;
}

// Convert datestring to time
function showTime(attribute_value) {
    /*var new_date = moment(new Date(attribute_value), 'DD/MM/YYYY');
        
    return new_date.format('h:mm A');*/

    var date_format = 'h:mm A';
    var new_date = makeDate(new Date(attribute_value), date_format);

    return new_date;
}


//
// Public functions
//

// Get all attributes
sq_personalise.fn.setAttributes = function(all_attributes) {
    sq_personalise['vars']['attributes'] = all_attributes;
};

// Convert special typed attributes
sq_personalise.fn.processAttributes = function(all_attributes, attribute_list) {

    // Add current date to attributes list
    attribute_list['AVAILABLE_DATE'] = new Date();
    
    // Iterate and modify attributes
    Object.keys(attribute_list).map(function(attribute, attribute_index) {
        var attribute_data = all_attributes[attribute];

        if(typeof(attribute_data) !== 'undefined') {
            // Check attribute name for additional processing
            attribute_list[attribute] = checkAttributeStructure(attribute_list[attribute], attribute_data);

            // Check attribute type for conversion
            attribute_list[attribute] = checkAttributeType(attribute_list[attribute], attribute_data);
        }
    });

    return attribute_list;
};

// Filter list of items
sq_personalise.fn.filterItems = function(item_list, filter_rules) {
    var filtered_items = [];
    
    // Process an array of items
    item_list.forEach(function(item, item_index){
        // Look for audiences associated with an item
        // If they exist, determine if they match the filter rules
        // and assign an importance weighting
        var item_is_valid = false;
        var item_audiences = getAudiences(item);

        if(item['audiences'] === '[{"attr":{"ROLE":["STUDENT"]},"restrict":"Not"}]') {
            
        }

        if(item_audiences) {
            var item_weight = getItemWeight(item_audiences, filter_rules);

            if(item_weight > -1) {
                item['weight'] = item_weight;
                item_is_valid = true;
            } 
        } else {
            item['weight'] = 0;
            item_is_valid = true;
        }

        // Add item to filtered list
        if(item_is_valid) {
            filtered_items.push(item);
        }
    });

    // Sort the items by weight
    return filtered_items.sort(sortDescBy('weight'));
};

// Convert attributes found in string
sq_personalise.fn.renderUserAttributes = function(content, user_attributes) {
    var attribute_pattern = /{{{[A-Z0-9_]+}}}/g;
    var content_results = content.match(attribute_pattern);

    var fn_pattern = /{{{fn__([a-z]+)\(([A-Z0-9_]+)\)}}}/g;
    var fn_results = content.match(fn_pattern);

    if(content_results !== null) {
        content_results.forEach(function(result, result_index) {
            var clean_result = result.replace('{{{', '').replace('}}}', '');
            var attribute_value = user_attributes[clean_result];

            if(typeof(attribute_value) !== 'undefined') {
                content = content.replace(result, attribute_value);
            }
        });
    }

    if(fn_results !== null) {
        fn_results.forEach(function(result, result_index) {
            var fn_name = /{{{fn__([a-z]+)/;
            var attr_name = /\(([A-Z0-9_]+)\)/;
            
            var fn_name_result = result.match(fn_name);
            var attr_name_result = result.match(attr_name);

            if(fn_name_result !== null) {
                switch(fn_name_result[1]) {
                    case 'date':
                        if(attr_name_result !== null) {
                            var attribute_value = user_attributes[attr_name_result[1]];
                            //check if the user has this attribute
                            if(typeof attribute_value !== "undefined"){
                                content = content.replace(result, showDate(attribute_value));
                            }
                            
                        }
                        
                        break;
                    case 'time':
                            if(attr_name_result !== null) {
                                var attribute_value = user_attributes[attr_name_result[1]];

                                if(typeof attribute_value !== "undefined"){
                                    content = content.replace(result, showTime(attribute_value));
                                }
                            }
                            
                            break;
                }
            }
        });
    }

    return content;
};


//
// Private functions
//

// Determine if the content is tagged with audiences
function getAudiences(item) {
    var item_audiences = item['audiences'];

    if(typeof(item_audiences) !== 'undefined') {
        if(typeof(item_audiences) === 'string') {
            if(item_audiences === '') {
                return false;
            }
            
            item_audiences = JSON.parse(item_audiences);
        }
    
        if(item_audiences.length > 0) {
            if (typeof(item_audiences[0]['attr']) !== "undefined"){
                return item_audiences;
            }
        }
    }
    
    return false;
}

// Determine an item's position in the array
function getItemWeight(item_audiences, filter_rules) {
    var item_is_valid = true;
    var item_weight = 0;
    var must_or_count = 0;
    var must_or_matches = 0;

    // Inspect each audience and check for matching filter rules
    item_audiences.forEach(function(audience, audience_index) {
        var audience_matches_rules = true;

        // Check for defined rules
        if(typeof(filter_rules) === 'undefined') {
            // Audience can't match if there are no rules
            audience_matches_rules = false;
        } else {
            // Check if the audience matches
            var must_not_match = false;
            var audience_weight = getAudienceWeight(audience, filter_rules, must_not_match);

            if(audience_weight > -1) {
                // Audience matched
                item_weight += audience_weight;

                if (isRestrictedBy(audience, 'MustOR')){
                    must_or_count += 1;
                    must_or_matches += 1;
                }
            } else if(isRestrictedBy(audience, 'Not')) {
                // Audience did not match. Check if it has that restriction
                must_not_match = true;
                item_weight += getAudienceWeight(audience, filter_rules, must_not_match);
                audience_matches_rules = false;
            } else {
                audience_matches_rules = false;
            }
        }

        // Determine whether the item is valid
        if(audience_matches_rules) {
            // The audience passed restrictions
            // If it shouldn't match, prevent it from passing
            if(isRestrictedBy(audience, 'Not')) {
                item_is_valid = false;
            }
        } else {
            // The audience did not pass restrictions
            if(isRestrictedBy(audience, 'Exists')) {
                item_is_valid = false;
            } else if(isRestrictedBy(audience, 'Must')) {
                item_is_valid = false;
            } else if(isRestrictedBy(audience, 'MustOR')){
                must_or_count += 1;
            }
        }
    });

    // If there are any audiences where at least one must match (e.g. 'MustOr')
    // and this condition has not been met, this item has not passed
    if (must_or_count > 0 && must_or_matches < 1){
        item_is_valid = false;
    }

    if(!item_is_valid) {
        item_weight = -1;
    }

    return item_weight;
}

function getAudienceWeight(audience, filter_rules, must_not_match) {
    var match_result = true;
    var audience_attributes = audience['attr'];

    for (var attribute in audience_attributes){
        var audience_val = audience_attributes[attribute];
        var user_val = filter_rules[attribute];

        if (typeof(user_val) !== 'undefined') {
            if (isRestrictedBy(audience, 'Exists')) {
                // Passed
            } else if (matchAttribute(attribute, audience_val, user_val)){
                // Passed
            } else {
                match_result = false;
            }
        } else {
            // No matching filter rule
            // Exception for special case of 'no-date-set' for dates which are not set
            if (attribute === "no-date-set"){
                // Passed
            } else if(audience_val === false){
                // This could be a boolean value. If the rule doesn't exist we are good
                // Passed
            } else {
                match_result = false;
            }
        }
    };

    // Determine audience weight
    if(match_result) {
        if(typeof(audience['weight']) !== 'undefined') {
            // Audience matched with a specific weight
            return audience['weight'];
        }
        
        // Audience matched without a specific weight
        return 0;
    }

    // Audience didn't match
    // Check if this is a valid case
    if(must_not_match) {
        if(typeof(audience['weight']) !== 'undefined') {
            // Audience has a specific weight
            return audience['weight'];
        }

        return 0;
    }

    // No audience matched and it's assumed it should have matched
    return -1;
}

// compare a rule to a value and return true or false
function matchAttribute (attribute_name, audience_value, filter_value){
    var ruleDateStart, ruleDateEnd, ruleDateTimeStart, ruleDateTimeEnd, nowDate, nowTime, possibleDate, valueDate;

    possibleDate = false;
    if (typeof(filter_value) !== "undefined"){
        if (typeof(filter_value) === 'string'){
            if (filter_value.match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}(T[0-9]{2}:[0-9]{2}:[0-9]{2}(\.[0-9]{3})?Z)?$/)){
                possibleDate = true;
                valueDate = new Date(filter_value);
            }
        // is it a date type?
        }else if(Object.prototype.toString.call(filter_value).match('Date')){
            // make sure it is not an invalid date
            if (!isNaN(filter_value.getTime())){
                possibleDate = true;
                valueDate = filter_value;
            }
        }
    }
    // special case for available date - this is compared against the current date - unless overridden in the settings
    if (attribute_name === "AVAILABLE_DATE"){
        if (typeof(filter_value) === "undefined"){
            nowDate = new Date();
        }else{
            nowDate = new Date(filter_value);
        }
        if (typeof(audience_value['from']) !== "undefined" && typeof(audience_value['to']) !== "undefined"){
            ruleDateStart = new Date(audience_value['from']);
            ruleDateEnd = new Date(audience_value['to']);
            if (ruleDateStart && ruleDateEnd){
                ruleDateTimeStart = ruleDateStart.getTime();
                ruleDateTimeEnd = ruleDateEnd.getTime();
                nowTime = nowDate.getTime();
                // is now inside the date start and end?
                if (nowTime <= ruleDateTimeEnd && nowTime >= ruleDateTimeStart){
                    return true;
                }else{
                    return false;
                }
            }else{
                // audience not properly set - so defaulting to allow match
                return true;
            }
        }else{
            // audience not properly set - so defaulting to allow match
            return true;
        }

    // special case if the target filter value would be a date, but the rule is set to 'no'
    } else if (audience_value === "no-date-set"){
        if (filter_value){
            if (typeof(filter_value.getDate) !== "undefined"){
                if (!filter_value.getDate()){
                    // invalid date
                    return true;
                }else{
                    return false;
                }
            }else{
                // undefined date
                return true;
            }
            return true;
        }else{
            // value not set
            return true;

        }
    // special case for the target value is a date
    } else if (possibleDate){
        // because this is a date, we want to check against
        // yes, no, future, past values for this date
        switch(audience_value){
            case "yes":
                return true;
            case "no":
                // should only occur with cancelling a date in the testing tool
                if (!valueDate.getDate()){
                    return true;
                }else{
                    return false;
                }
            case "future":
                if (valueDate.getTime() > new Date().getTime()){
                    return true;
                }else{
                    return false;
                }
            case "past":
                if (valueDate.getTime() < new Date().getTime()){
                    return true;
                } else {
                    return false;
                }
        }
    } else {

        if(attribute_name === 'SRV_INDCTR') {
            
        }

        // normalise audience value to array
        audience_value = convertToArray(audience_value);

        // normalise filter value to array
        filter_value = convertToArray(filter_value);

        // Simplify filter values from SRV_INDCTR and TO_DO_LIST attributes
        var structured_attributes = ['SRV_INDCTR', 'TO_DO_LIST']
        if (structured_attributes.indexOf(attribute_name) !== -1) {
            filter_value = simplifyStructuredAttribute(attribute_name, filter_value);
        }

        // check whether the two arrays intersect (e.g. does one or more values match one or more of the rule attribute selected values)
        var arrays = [audience_value, filter_value];
        var intersection = arrays.reduce(function(a, b) {
            return a.filter(function(filter_value) {
                //return b.includes(filter_value);
                return b.indexOf(filter_value) != -1;
            });
        });

        if (intersection.length > 0){
            return true;
        } else {
            return false;
        }
    }
}

// Check the item's audience restriction
function isRestrictedBy(item_audience, restriction){
    if (typeof(item_audience['restrict']) !== "undefined"){
        if (item_audience['restrict'] === restriction){
            return true;
        }
    }

    return false;
}

// Convert value to array
function convertToArray(value) {
    // Arrays
    if (Array.isArray(value)){
        return value;
    }

    // String
    if (typeof(value) === "string"){
        return value.split(/,\s*/);
    }
    
    // Boolean
    if (typeof(value) === "boolean"){
        return [value];
    }
    
    // Object
    return Object.keys(value);
}


function simplifyStructuredAttribute(attribute_key, attribute_value) {

    if(attribute_key === 'SRV_INDCTR') {
        var attribute_list = [];

        if(Array.isArray(attribute_value))

        attribute_value.forEach(function(attr, attr_index){
            attribute_list.push(attr['NSI_CDE']);
        });

        return attribute_list;
    }

    if(attribute_key === 'TO_DO_LIST') {
        var attribute_list = [];

        attribute_value.forEach(function(attr, attr_index){
            attribute_list.push(attr['TO_LIST_CDE']);
        });

        return attribute_list;
    }

    return [];
}